/**
 * UpdatingOverlay — OTA 적용 중 최상위 블로킹 오버레이.
 *
 * "지금 업데이트" → applyOtaBundle(set) 이 WebView 를 reload 하기까지의 구간을
 * 딤드 + 스피너로 덮어 "업데이트 중입니다" 를 보여주고, 그동안 모든 조작(터치)을
 * 차단한다. 하드웨어/브라우저 뒤로가기 차단은 UpdatePrompt 의 useDialogBackBinding
 * (blockClose) 가 담당. 적용 성공 시 reload 로 이 컴포넌트째 사라진다.
 */
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import styles from "./UpdatingOverlay.module.css";

function UpdatingOverlay() {
  const { t } = useTranslation();
  return createPortal(
    <div
      className={styles.backdrop}
      role="alert"
      aria-busy="true"
      aria-live="assertive"
      // 백드롭 위 클릭/터치를 여기서 소비 — 하위로 전달 안 함.
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.spinner} aria-hidden="true" />
      <span className={styles.label}>{t("update.applying")}</span>
    </div>,
    document.body,
  );
}

export default UpdatingOverlay;
